// src/components/Profile/AvatarSection.js
import React, { useState } from 'react'
import {
  Box,
  Avatar,
  IconButton,
  Tooltip,
  Typography,
  CircularProgress
} from '@mui/material'
import { PhotoCamera } from '@mui/icons-material'
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'
import { storage, db } from '../../firebase'
import { doc, updateDoc } from 'firebase/firestore'

// Çoklu dil desteği
import { useTranslation } from 'react-i18next'

export default function AvatarSection({ userData, setUserData, setError, setSuccess }) {
  const { t } = useTranslation() // i18n Hook

  const [avatar, setAvatar] = useState(null)
  const [avatarPreview, setAvatarPreview] = useState(userData.avatarUrl || '')
  const [uploading, setUploading] = useState(false)

  const handleAvatarChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0]
      setAvatar(file)
      setAvatarPreview(URL.createObjectURL(file))
    }
  }

  const handleUpload = async () => {
    if (!avatar) return
    setUploading(true)
    try {
      const avatarRef = ref(storage, `avatars/${userData.uid}/${avatar.name}`)
      await uploadBytes(avatarRef, avatar)
      const avatarUrl = await getDownloadURL(avatarRef)
      const userDoc = doc(db, 'users', userData.uid)
      await updateDoc(userDoc, { avatarUrl })

      setUserData((prev) => ({ ...prev, avatarUrl }))
      setSuccess(t('profileAvatar.avatarUpdateSuccess')) // <-- Başarı mesajı
    } catch (err) {
      console.error('Avatar güncellenirken hata:', err)
      setError(t('profileAvatar.avatarUpdateError')) // <-- Hata mesajı
    } finally {
      setUploading(false)
    }
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Tooltip title={t('profileAvatar.tooltipTitle')}>
        <label htmlFor="avatar-upload">
          <input
            accept="image/*"
            id="avatar-upload"
            type="file"
            style={{ display: 'none' }}
            onChange={handleAvatarChange}
          />
          <IconButton component="span" sx={{ position: 'relative' }}>
            <Avatar
              src={avatarPreview}
              alt="User Avatar"
              sx={{ width: 120, height: 120 }}
            />
            <PhotoCamera
              sx={{
                position: 'absolute',
                bottom: 0,
                right: 0,
                bgcolor: 'background.paper',
                borderRadius: '50%',
              }}
            />
          </IconButton>
        </label>
      </Tooltip>

      <Typography variant="body2" sx={{ mt: 1, textAlign: 'center' }}>
        {t('profileAvatar.clickToUpdate')}
      </Typography>

      {avatar && (
        <Box sx={{ mt: 2 }}>
          <IconButton
            color="primary"
            onClick={handleUpload}
            disabled={uploading}
            sx={{ mr: 1 }}
          >
            {uploading ? <CircularProgress size={24} /> : t('profileAvatar.uploadBtn')}
          </IconButton>
        </Box>
      )}
    </Box>
  )
}